var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoProcessingUpdate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_update",
    d: "M3.844,664.588a.654.654,0,0,1-.654-.654h0V649.25a.654.654,0,0,1,.654-.654H14.561a2.738,2.738,0,0,0-.226.2l-1.26,1.259H4.817v13.061H17.528v-8.055l1.527-1.533a1.155,1.155,0,0,0,.1-.1v10.5a.654.654,0,0,1-.654.654h0Zm4.778-8.14,2.877,2.888-3.9,1.026Zm.7-.7,6.912-6.924a.647.647,0,0,1,.914-.006l.006.006L19,650.671a.647.647,0,0,1,.005.914l-.005.006-6.909,6.925Zm9.18,8.839H3.844a.654.654,0,0,1-.654-.654V649.246a.654.654,0,0,1,.654-.654H14.561a2.8,2.8,0,0,0-.226.2l-1.26,1.26H4.817v13.061H17.528v-8.055l1.527-1.532a1.34,1.34,0,0,0,.1-.1v10.5A.654.654,0,0,1,18.5,664.588ZM7.6,660.362l1.026-3.914,2.877,2.888Zm4.494-1.841-2.767-2.767,6.912-6.925a.653.653,0,0,1,.92,0L19,650.675a.648.648,0,0,1,0,.92Z",
    transform: "translate(-3.19 -648.592)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoProcessingUpdate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_processing_update.b5b009dbb9e42cb11ec362405a360bf9.svg";